"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUpdateTimezoneDto = instanceOfUpdateTimezoneDto;
exports.UpdateTimezoneDtoFromJSON = UpdateTimezoneDtoFromJSON;
exports.UpdateTimezoneDtoFromJSONTyped = UpdateTimezoneDtoFromJSONTyped;
exports.UpdateTimezoneDtoToJSON = UpdateTimezoneDtoToJSON;
exports.UpdateTimezoneDtoToJSONTyped = UpdateTimezoneDtoToJSONTyped;
/**
 * Check if a given object implements the UpdateTimezoneDto interface.
 */
function instanceOfUpdateTimezoneDto(value) {
    if (!('timezoneId' in value) || value['timezoneId'] === undefined)
        return false;
    return true;
}
function UpdateTimezoneDtoFromJSON(json) {
    return UpdateTimezoneDtoFromJSONTyped(json, false);
}
function UpdateTimezoneDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'timezoneId': json['timezoneId'],
    };
}
function UpdateTimezoneDtoToJSON(json) {
    return UpdateTimezoneDtoToJSONTyped(json, false);
}
function UpdateTimezoneDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'timezoneId': value['timezoneId'],
    };
}
